import { render, staticRenderFns } from "./W4List.vue?vue&type=template&id=4dc9638c&scoped=true&"
import script from "./W4List.vue?vue&type=script&lang=ts&"
export * from "./W4List.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9638c",
  null
  
)

export default component.exports